import React from 'react';
import { motion } from 'framer-motion';
const StorySection: React.FC = () => {
  return <section className="w-full bg-background py-16" data-id="element-239">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl" data-id="element-240">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-2xl shadow-lg" data-id="element-241">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-secondary mb-8" data-id="element-242">
            Mi historia{' '}
            <span className="text-lg font-sans font-normal text-gray-600" data-id="element-243">
              (muy breve, pero poderosa)
            </span>
          </h2>
          <div className="space-y-6 text-lg" data-id="element-244">
            <p className="font-medium text-primary-dark" data-id="element-245">
              A los 31 años me dijeron: "Belén, tienes cáncer de riñón."
            </p>
            <p data-id="element-246">
              Pensé que por ser joven estaba libre de riesgos. Hasta que la vida
              me frenó.
            </p>
            <p data-id="element-247">
              Después de dos embarazos, kilos emocionales y una autoestima rota
              frente al espejo…
            </p>
            <p className="font-medium" data-id="element-248">me obligué a cambiar.</p>
            <div className="flex flex-col md:flex-row justify-between gap-4 py-4" data-id="element-249">
              <div className="flex items-center gap-3" data-id="element-250">
                <span className="text-2xl bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center font-bold" data-id="element-251">
                  🥇
                </span>
                <span data-id="element-252">Me costó 12 años.</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-253">
                <span className="text-2xl bg-green-600 text-white w-10 h-10 rounded-full flex items-center justify-center font-bold" data-id="element-254">
                  💚
                </span>
                <span data-id="element-255">Hoy tengo 43.</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-256">
                <span className="text-2xl bg-accent text-white w-10 h-10 rounded-full flex items-center justify-center font-bold" data-id="element-257">
                  ✨
                </span>
                <span data-id="element-258">Y soy otra mujer.</span>
              </div>
            </div>
            <p className="text-xl font-medium text-center mt-8" data-id="element-259">
              Tu cuerpo puede renacer con un cambio tan simple como: liberarte
              del azúcar.
            </p>
            <p className="text-center" data-id="element-260">
              Y quiero que tú lo consigas en 21 días, no en 12 años.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};
export default StorySection;